import { unauthApi } from 'api';
import {
  LoginRequest,
  RefreshTokenRequest,
  ResetPasswordRequest,
  SsoLoginRequest,
  TokenResponse,
  UpdatePasswordRequest,
  VerificationRequest,
} from './dtos';

export const login = async (data: LoginRequest) => {
  return unauthApi.post<TokenResponse>(undefined, `/auth/login`, { body: data });
};

export const verifyEmail = async (data: VerificationRequest) => {
  return unauthApi.post<string>(undefined, `/auth/verify`, { body: data });
};

export const resetPassword = async (data: ResetPasswordRequest) => {
  return unauthApi.post<string>(undefined, `/auth/reset`, { body: data });
};

export const updatePassword = async (data: UpdatePasswordRequest) => {
  return unauthApi.put<string>(undefined, `/auth/reset`, { body: data });
};

export const ssoLogin = async (data: SsoLoginRequest) => {
  return unauthApi.post<TokenResponse>(undefined, `/auth/sso`, { body: data });
};

export const logout = async (data: RefreshTokenRequest) => {
  return unauthApi.post<void>(undefined, `/auth/logout`, { body: data });
};

export const refreshToken = async (data: RefreshTokenRequest) => {
  return unauthApi.post<TokenResponse>(undefined, `/auth/refresh`, { body: data });
};
